import React, { useContext } from 'react';
import { EmpaqueContext } from '../contexts/EmpaqueContext';

const useEmpaquetado = () => useContext(EmpaqueContext);

export default useEmpaquetado;
